import { KeyboardEventHandler, RefObject } from "react";

import { InputBase, Stack, Typography } from "@mui/material";

interface Props {
  editValue: string;
  setEditValue: (value: string) => void;
  inputRef: RefObject<HTMLInputElement | null>;
  extension: string;
  confirmRename: () => void;
  handleKeyDown: KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export function RenameInput({ editValue, setEditValue, inputRef, extension, confirmRename, handleKeyDown }: Props) {
  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <InputBase
        inputRef={inputRef}
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={confirmRename}
        onKeyDown={handleKeyDown}
        fullWidth
        sx={{ typography: "body2" }}
      />
      {extension && (
        <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
          {extension}
        </Typography>
      )}
    </Stack>
  );
}
